import type { ReactNode } from 'react'
import { NotFoundView } from '#src/components/NotFoundView.js'
import { languageService } from '#src/languageService.js'
import SelectedCaseComponent from '#src/pages/selected-cases/case/SelectedCaseComponent.js'
import { getSelectedCase } from '#src/pages/selected-cases/selectedCasesData.js'
import { mergeMeta, noindexUnlessTranslated, seoTagsToMeta } from '#src/seo.js'
import type { Route } from './+types/selected-case.route.js'

export async function loader({ request, params }: Route.LoaderArgs) {
  const { caseSlug } = params
  const lang = languageService.langFromRequest(request)
  const selectedCase = await getSelectedCase(caseSlug, lang)

  const meta = selectedCase
    ? [
        ...seoTagsToMeta(selectedCase.seo),
        ...noindexUnlessTranslated(`/selected-cases/${caseSlug}`, lang),
      ]
    : []
  return { selectedCase, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function SelectedCasePage({ loaderData }: Route.ComponentProps): ReactNode {
  if (!loaderData.selectedCase) {
    return <NotFoundView />
  }

  return <SelectedCaseComponent selectedCase={loaderData.selectedCase} />
}
